import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import type { State } from "../store";
import { updateHabit, loadHabit } from "./actionCreators";
import { getHabit } from "./selectors";
import { getAuthenticatedUserId } from "../user/selectors";
import type { Habit, EditableHabit } from "./types";
import EditHabit from "./components/EditHabit";
import { useParams } from "react-router-dom";

export type OwnProps = {};
export type StateProps = {};
export type DispatchProps = {
  updateHabit: (arg0: Habit, arg1: EditableHabit, arg2: () => void) => void;
  loadHabit: (arg0: string, arg1: number) => void;
};
export type LoadingComponentProps = StateProps & DispatchProps & OwnProps;

const mapDispatchToProps = {
  updateHabit,
  loadHabit,
};

const LoadingComponent = function (props: LoadingComponentProps) {
  const { userId1, userId2, createdms: createdmsstr } = useParams();
  const createdms = parseInt(createdmsstr);
  const userId = userId1 + ":" + userId2;
  const habit = useSelector<State, Habit | null | undefined>((state) =>
    getHabit(state, userId, createdms)
  );
  const authenticatedUserId = useSelector<State>((state) =>
    getAuthenticatedUserId(state)
  );

  const isOwner = userId === authenticatedUserId;

  const { loadHabit, ...otherProps } = props;

  useEffect(() => {
    if (habit == null || !isOwner) {
      loadHabit(userId, createdms);
    }
  }, [isOwner, habit, userId, createdms, loadHabit]);
  if (habit == null || !isOwner) {
    return null;
  } else {
    return <EditHabit {...otherProps} isOwner={isOwner} habit={habit} />;
  }
};

export default connect<StateProps, DispatchProps, OwnProps>(
  null,
  mapDispatchToProps
)(LoadingComponent);
